import cn from 'classnames';
import {Link} from '../../components';
import styles from './Author.module.scss';
import icon from '../../resources/pics/author.svg';

export const Author = ({handler}) => {
    const info = [
        {id: 0,text: 'А помните головоломку на задней стороне коробки хлопьев, в которой нужно было соединить пары?'},
        {id: 1,text: 'И вот мы выросли: на хлопья денег не хватает, а вместо интерактивчиков на картонке нужно решать, куда вложить остатки бюджета.'},
        {id: 2, text: 'Но давайте отвлечёмся от рутины и вспомним, как соединять старые добрые пары, пока герои любимых сериалов 2х2 инвестируют в странные и подозрительные вещи.'},
        {id: 3, text: 'И если их финансовые решения будут неудачными, то 2x2 со Сбером придут на помощь со своей кидалтской магией и подскажут вариант получше!'}
    ];

    const text = info.map(item => {
        const {id, text} = item;

        const little = <p key={id} className={cn('text-small', styles.little)}>{text}</p>,
            big = <p key={id} className={cn('text-lead', styles.big)}>{text}</p>;

        return (id < 1) ? big : little;
    });

    return (
        <div className={styles.modal}>

            <div className={styles.author}>
                <img src={icon} alt="Телеканал 2x2"/>
                <div className={styles.text}>
                    <div className={styles.name}>Телеканал 2x2</div>
                    <div className={cn(styles.name, styles.role)}>Ваш финансовый советник</div>
                </div>
            </div>
            {text}
            <Link tag={'div'} text="Играть" onClick={handler}/>
        </div>
    );
};
